import { load } from 'recaptcha-v3'

// reCAPTCHA v3 をフォーム送信時に実行するモジュール
// meta[name="recaptcha-site-key"] にサイトキーが設定され、
// form[data-recaptcha-action] が存在する場合のみ動作する

const SITE_KEY = document.querySelector('meta[name="recaptcha-site-key"]')?.content

const recaptcha = async () => {
    const forms = document.querySelectorAll('form[data-recaptcha-action]')
    if (!SITE_KEY || forms.length === 0) return

    // recaptcha-v3 が grecaptcha 本体の読み込みを行う
    const instance = await load(SITE_KEY)

    forms.forEach((form) => {
        form.addEventListener('submit', async (e) => {
            e.preventDefault()

            // 二重送信防止
            const submitButton = form.querySelector('button[type="submit"]')
            if (submitButton?.disabled) return
            if (submitButton) submitButton.disabled = true

            const tokenInput = form.querySelector('input[name="g-recaptcha-response"]')

            try {
                const token = await instance.execute(form.dataset.recaptchaAction)
                if (tokenInput) tokenInput.value = token
            } catch (err) {
                // 取得失敗時はトークン無しで送信し、サーバ側バリデーションでエラー表示
                console.error('reCAPTCHA failed:', err)
            }

            // form.submit() は submit イベントを発火しないため再帰しない
            form.submit()
        })
    })
}

export default recaptcha